import React, { useEffect, useState } from "react";
import Conversations from "../../../../../components/Processes/conversations/Conversations";
import useMessages from "../../../actions/useMessages";
import TemporaryNotification from "~/components/toast-notification/AttachmentTemporaryNotification";
import AttachmentSuccess from "~/components/toast-notification/AttachmentSuccess";

const PublicConversations = () => {
  const [messages, setMessages] = useState(null);
  const [restoreSuccess, setRestoreSuccess] = useState("");
  const {
    fetchPublicMessages,
    isMessageLoading,
    formatDate,
    setIsMessageLoading,
    isPublic,
    deleteConversation,
    deleteLoading,
    setDeleteLoading,
    deleteModal,
    setDeleteModal,
    selectedMessage,
    setSelectedMessage,
    processdata,
    deleteCommentModal,
    setDeleteCommentModal,
    notificationMessage,
    setNotificationMessage,
    restoreConversation,
    resetPaginationState,
  } = useMessages({
    fetchMessages: () => {},
    relatedType: "PROCESS",
    serviceData: {},
  });

  // Initial fetch on mount
  useEffect(() => {
    const getMessages = async () => {
      setIsMessageLoading(true);
      const data = await fetchPublicMessages("INITIAL");
      // console.log("✅ Initial load complete:", data?.data, "messages");
      setMessages(data);
    };

    getMessages();
  }, []);

  // Fetch messages handler
  const fetchMessageshandler = async (fetchDataType = "INITIAL") => {
    try {
      if (fetchDataType === "INITIAL") {
        resetPaginationState();
        setIsMessageLoading(true);
        const data = await fetchPublicMessages("INITIAL");
        setMessages(data);
      } else if (fetchDataType === "FETCHPREVDATA") {
        const data = await fetchPublicMessages("FETCHPREVDATA");

        if (data?.data?.length > 0) {
          setMessages((prevMessages) => {
            const newMessages = {
              ...data,
              data: [...data.data, ...(prevMessages?.data || [])],
            };
            return newMessages;
          });
        }
      } else if (fetchDataType === "FETCHNEXTDATA") {
        const data = await fetchPublicMessages("FETCHNEXTDATA");

        if (data?.data?.length > 0) {
          setMessages((prevMessages) => {
            const newMessages = {
              ...data,
              data: [...(prevMessages?.data || []), ...data.data],
            };
            return newMessages;
          });
        }
      }
    } catch (error) {
      setIsMessageLoading(false);
    }
  };

  const deleteConversationHandler = async (id) => {
    await deleteConversation(id);
    setDeleteLoading(false);
    setRestoreSuccess("");
    setNotificationMessage(
      "Your message and document has been deleted from this conversation.",
    );
    setDeleteCommentModal(false);
    setDeleteModal(false);
    await fetchMessageshandler("INITIAL");
  };

  const restoreConversationHandler = async () => {
    setDeleteLoading(false);
    await restoreConversation(selectedMessage.id);
    setNotificationMessage("");
    setSelectedMessage(null);
    setRestoreSuccess(
      "Your message or document has been restored successfully.",
    );
    setTimeout(async () => {
      await fetchMessageshandler("INITIAL");
    }, 2000);
  };

  return (
    <>
      {restoreSuccess && (
        <AttachmentSuccess
          setMessages={setRestoreSuccess}
          successMsg={restoreSuccess}
        />
      )}
      {notificationMessage && (
        <TemporaryNotification
          setMessages={setNotificationMessage}
          successMsg={notificationMessage}
          onUndo={restoreConversationHandler}
        />
      )}
      <Conversations
        messages={messages?.data}
        fetchMessages={fetchMessageshandler}
        isMessageLoading={isMessageLoading}
        formatDate={formatDate}
        isPublic={isPublic}
        deleteConversation={deleteConversationHandler}
        isDeleteLoading={deleteLoading}
        setDeleteLoading={setDeleteLoading}
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        selectedMessage={selectedMessage}
        setSelectedMessage={setSelectedMessage}
        entitydata={processdata?.entityData}
        processdata={processdata}
        relatedType="PROCESS"
        deleteComment={deleteCommentModal}
        setDeleteComment={setDeleteCommentModal}
      />
    </>
  );
};

export default PublicConversations;
